module.exports = __webpack_public_path__ + "static/img/wisd.a99f4b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wisd.png
// module id = jC3P
// module chunks = 1